import React, { useState, useRef } from 'react';
import axios from 'axios';
import './CSS/add_techno_news.css';

const AddNews = () => {
  const [header, setHeader] = useState('');
  const [paragraph, setParagraph] = useState('');
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [responseMessage, setResponseMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    if (file) {
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage('');

    const formData = new FormData();
    formData.append('header', header);
    formData.append('paragraph', paragraph);
    if (image) formData.append('image', image);

    try {
      const res = await axios.post('https://weynibirhan.com.et/add_techno_news.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setResponseMessage(res.data.message || 'News posted.');
      setHeader('');
      setParagraph('');
      setImage(null);
      setImagePreview(null);
      if (fileInputRef.current) fileInputRef.current.value = '';
    } catch (err) {
      setResponseMessage('Error posting news.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-news-container">
      <h2>Add Technology News</h2>
      <form onSubmit={handleSubmit} className="add-news-form">
        <input
          type="text"
          placeholder="Header"
          value={header}
          onChange={(e) => setHeader(e.target.value)}
          required
        />
        <textarea
          placeholder="Paragraph"
          value={paragraph}
          onChange={(e) => setParagraph(e.target.value)}
          required
          minLength={10}
        />
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          ref={fileInputRef}
        />
        {imagePreview && (
          <img src={imagePreview} alt="Preview" style={{ maxWidth: '100%', marginBottom: '10px' }} />
        )}
        <button type="submit" disabled={loading}>
          {loading ? 'Posting...' : 'Post News'}
        </button>
      </form>
      {responseMessage && <p className="response-message">{responseMessage}</p>}
    </div>
  );
};

export default AddNews;
